import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { User } from '../models/user.model';
import { Config } from '../app.config';
import { Observable, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

import { environment } from '../../environments/environment'
import { Instance } from '../models/instance.model';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs/observable/of';


@Injectable()
export class AuthenticationService {
    /** Variables */
    private options: RequestOptions
    public currentUser: User;
    public currentUserRole: String;
    public instancesIsChanged: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public initial = false;

    // Life Cycle Hooks
    constructor(private _http: Http, private _config: Config, private cookieService: CookieService) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers });
    }

    public getUser() {
        return this.authenticate().mergeMap((res) => {
            this.currentUser = JSON.parse(res._body).user;

            this.currentUserRole = this.currentUser.applications.filter(app => app.name == 'stubs')[0].role
            return this.getUserInstances().map((response: any[]) => {
                this.initializeUserInstance(response);
            }, this.handleError);
        }).catch((error) => {
            if (error.status === 401) {
                swal({
                    text: 'You are not authorized, you will be redirected to SSO',
                    icon: 'error'
                });
                setTimeout(() => {
                    window.location.href = this._config.ssoClientUrl
                }, 3000);
            }
            return Observable.throw(error);
        });
    }

    /**
     * Public Methods
     */

    /**
      * Get Current User from Service Storage OR SSO
      */
    public getCurrentUser(): User {

        if (this.currentUser && this.currentUser._id) {
            return this.currentUser;
        }

        this.authenticate().subscribe((res) => {
            this.currentUser = JSON.parse(res._body).user;

            if (this.currentUser && this.currentUser.instances) {

                if (this.currentUser.instances.length === 0) {
                    // No have Access To Stubs
                } else if (this.currentUser.instances.length === 1) {
                    // Have only one Instance
                    this.cookieService.set('instance', this.currentUser.instances[0].cookieName);
                }
            }
        }, (error) => {
            // Navigate to SSO login page
            swal({
                text: 'You are not authorized, you will be redirected to SSO',
                icon: 'error'
            });
            setTimeout(() => {
                window.location.href = this._config.ssoClientUrl;
            }, 3000);
        });
    }

    /**
     * Get User Data by user id
     * @param userId
     */
    public getUserById(userId: String) {
        return this._http
            .post(this._config.ssoUrl + '/id/user', { userId }, this.options)
            .catch(this.handleError);
    }

    /**
     * Authenticate User from SSO
     */
    public authenticate(): Observable<any> {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        headers.set('appName', 'stubs');
        const options = new RequestOptions({ headers });
        if (environment.ssoMode) {
            return this._http.post(this._config.ssoUrl + '/token/user', {}, options)
        } else {
            return Observable.of(
                {
                    _body: '{"valid":true,"user":{"_id":"5ac2451f4181c52195364538","email":"ahmed.osama-youssef@vodafone.com","username":"Ahmed Osama-Youssef","password":"62597","authToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjVhYzI0NTFmNDE4MWM1MjE5NTM2NDUzOCIsImVtYWlsIjoiYWhtZWQub3NhbWEteW91c3NlZkB2b2RhZm9uZS5jb20iLCJ1c2VybmFtZSI6IkFobWVkIE9zYW1hLVlvdXNzZWYiLCJwYXNzd29yZCI6IjYyNTk3IiwiYXBwbGljYXRpb25zIjpbeyJuYW1lIjoic3R1YnMiLCJtYXJrZXRzIjpbImRlIiwianMiLCJhdXMiLCJueiIsInNwIl19XX0sImlhdCI6MTU0MzgzMTEyNiwiZXhwIjoxNTQ1MDQwNzI2fQ.sWZ0tf512RYKBPxDFyiXAhGS4SmScQpdfcrF_NvEEzU","applications":[{"name":"stubs","markets":["de","js","aus","nz","sp"]}]}}'
                });
        }
    }

    /**
     * Get Current User Markets
     */
    public getUserInstances() {
        return this._http
            .get(this._config.baseUrl + '/v1/stubs/getUserInstances', this.options)
            .map(res => {
                return res ? res.json() : null;
            })
            .catch(this.handleError);
    }

    public initializeUserInstance(response) {
        if (response) {
            this.currentUser.instances = response;
            this.initial = true;
            this.instancesIsChanged.next(this.currentUser.instances);
            if (this.currentUser.instances.length === 1) {
                this.currentUser.selectedInstance = this.currentUser.instances[0];
                this.cookieService.set('instance', this.currentUser.selectedInstance.cookieName);

            } else if (this.currentUser.instances.length === 0) {
                this.currentUser.selectedInstance = null;
            }
        } else {
            this.currentUser.instances = [];
            this.currentUser.selectedInstance = null;
        }
    }

    /** Private Methods */
    private handleError(error: Response) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/Services/authentication.service.ts